const styles = {
  Introduction_container: {
    height: "auto",
    overflow: "visible"
  },
  Introduction_textContainer: {
    display: "flex",
    flexDirection: "column"
  },
  Introduction_image: {
    display: "block",
    width: "100%",
    maxWidth: "none",
    height: "auto",
    maxHeight: "none",
    objectFit: "contain"
  },
  Introduction_buttonLink: {
    textDecoration: "none",
    color: "inherit"
  },
}
export default styles;
